import { render, staticRenderFns } from "./ClinicDentistsTable.vue?vue&type=template&id=25583823&"
import script from "./ClinicDentistsTable.vue?vue&type=script&lang=js&"
export * from "./ClinicDentistsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports